/**
 * Banner 1010 — Banner 9's hero layout without the carousel or its per-slide
 * extras: a full-bleed background with a single highlighted headline centred in
 * the left column, and a dark right panel carrying a 432×432 hero image
 * (desktop only). No accreditation logos, CTAs, subtitle or programme pills, so
 * the section has no dynamic rows and no `metadata` group in the admin.
 *
 * Every value maps onto existing shared `banner` columns — the right-panel hero
 * image reuses `image` (with `image_alt`) and the mobile background reuses
 * `mobile_image` — so no new DB columns are required. The desktop background is
 * a bundled asset (`/images/banner-bg.webp`) and is not admin-driven.
 */

export const BANNER_1010_CONSTANTS = {
  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title (wrap highlighted words in { }, use {{ }} to also break the line)",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "e.g. Online {MBA} from Chandigarh University",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "title_color",
      // Mobile is fixed to white — the headline sits on the background photo
      // there, so an admin-picked dark colour would be unreadable.
      label: "Title color (desktop — mobile is always white)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_highlight_color",
      label: "Title highlight color ({ } words — applies on mobile and desktop)",
      value: "#FFD700",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFD700",
      required: false,
      defaultValue: "#FFD700",
    },
    {
      fieldName: "image",
      label: "Hero image (right panel, 432×432)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload the right-panel hero image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "image_alt",
      label: "Hero image alt text",
      value: "banner",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the hero image",
      required: false,
      defaultValue: "banner",
    },
    {
      fieldName: "mobile_image",
      label: "Mobile background image (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Falls back to the bundled desktop background when empty",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      // RGBA (not COLOR) so the admin can dial the panel's opacity — the alpha
      // slider lets the background photo show through the strip.
      label: "Right strip / hero panel color (opacity adjustable)",
      value: "rgba(3, 7, 18, 1)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(3, 7, 18, 1)",
      required: false,
      defaultValue: "rgba(3, 7, 18, 1)",
    },
    {
      fieldName: "hero_section_height",
      label: "Section height (px)",
      value: 564,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "564",
      required: false,
      defaultValue: 564,
    },
    {
      fieldName: "hero_container_max_width",
      label: "Content max width (px)",
      value: 1114,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "1114",
      required: false,
      defaultValue: 1114,
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],
};
